import pic1 from '../../images/Driveway1.jpg';
import pic2 from '../../images/Driveway2.jpg';
import pic3 from '../../images/Night3.jpg';
import pic4 from '../../images/Floorplan.jpg';
import pic5 from '../../images/Night1.jpg';
import pic6 from '../../images/Night2.jpg';
import pic7 from '../../images/Lanai.jpg';
import pic8 from '../../images/Pool1.jpg';
import pic9 from '../../images/Pool2.jpg';
import pic10 from '../../images/Pool3.jpg';
import pic11 from '../../images/Pool4.jpg';
import pic12 from '../../images/Pool5.jpg';
import pic13 from '../../images/Media1.jpg';
import pic14 from '../../images/Media2.jpg';
import pic15 from '../../images/Media3.jpg';
import pic16 from '../../images/Loft.jpg';
import pic17 from '../../images/Garage1.jpg';
import pic18 from '../../images/Garage2.jpg';
import pic19 from '../../images/Dining1.jpg';
import pic20 from '../../images/Dining2.jpg';
import pic21 from '../../images/Kitchen1.jpg';
import pic22 from '../../images/Laundry.jpg';
import pic23 from '../../images/GreatRoom1.jpg';
import pic24 from '../../images/GreatRoom2.jpg';
import pic25 from '../../images/GuestSuite.jpg';
import pic26 from '../../images/MasterBed1-1.jpg';
import pic27 from '../../images/MasterBed1-2.jpg';
import pic28 from '../../images/MasterBath1.jpg';
import pic29 from '../../images/MasterBed2-1.jpg';
import pic30 from '../../images/MasterBed2-2.jpg';
import pic31 from '../../images/MasterBath2.jpg';
import pic32 from '../../images/Bedroom3-1.jpg';
import pic33 from '../../images/Bedroom3-2.jpg';
import pic34 from '../../images/Bath3.jpg';
import pic35 from '../../images/Bedroom4-1.jpg';
import pic36 from '../../images/Bedroom4-2.jpg';
import pic37 from '../../images/Bath4.jpg';
import pic38 from '../../images/Bedroom7-1.jpg';
import pic39 from '../../images/Bedroom7-2.jpg';
import pic40 from '../../images/Bath7.jpg';
import pic41 from '../../images/Bedroom5-1.jpg';
import pic42 from '../../images/Bedroom5-2.jpg';
import pic43 from '../../images/Bath5.jpg';
import pic44 from '../../images/Bedroom6-1.jpg';
import pic45 from '../../images/Bedroom6-2.jpg';
import pic46 from '../../images/Bath6.jpg';
import pic47 from '../../images/Bath8.jpg';

export const images = [
    {
      original: pic1,
      thumbnail: pic1,
      description: "8 bed/8 bath 2 story located in the Encore Resort"
    },
    {
      original: pic2,
      thumbnail: pic2,
      description: "3 private parking spots in the driveway"
    },
    {
      original: pic3,
      thumbnail: pic3,
      description: "1 block from the Sinclair Drive gate on Fairfax Drive"
    },
    {
      original: pic4,
      thumbnail: pic4,
      description: "Floorplan"
    },
    {
      original: pic5,
      thumbnail: pic5,
      description: "Poolside bonfire"
    },
    {
      original: pic6,
      thumbnail: pic6,
      description: "Nighttime pool and spa"
    },
    {
      original: pic7,
      thumbnail: pic7,
      description: "Shaded Lanai"
    },
    {
      original: pic8,
      thumbnail: pic8,
      description: "Sunshine swimming"
    },
    {
      original: pic9,
      thumbnail: pic9,
      description: "Sunshine swimming"
    },
    {
      original: pic10,
      thumbnail: pic10,
      description: "Sunshine swimming"
    },
    {
      original: pic11,
      thumbnail: pic11,
      description: "Sunshine swimming"
    },
    {
      original: pic12,
      thumbnail: pic12,
      description: "Sunshine swimming"
    },
    {
      original: pic13,
      thumbnail: pic13,
      description: "Movie Theater room"
    },
    {
      original: pic14,
      thumbnail: pic14,
      description: "Movie Theater room"
    },
    {
      original: pic15,
      thumbnail: pic15,
      description: "Movie Theater room"
    },
    {
      original: pic16,
      thumbnail: pic16,
      description: "Loft with arcade game"
    },
    {
      original: pic17,
      thumbnail: pic17,
      description: "Game room"
    },
    {
      original: pic18,
      thumbnail: pic18,
      description: "Game room"
    },
    {
      original: pic19,
      thumbnail: pic19,
      description: "Dining"
    },
    {
      original: pic20,
      thumbnail: pic20,
      description: "Dining"
    },
    {
      original: pic21,
      thumbnail: pic21,
      description: "Kitchen"
    },
    {
      original: pic22,
      thumbnail: pic22,
      description: "Laundry on both floors"
    },
    {
      original: pic23,
      thumbnail: pic23,
      description: "Living room"
    },
    {
      original: pic24,
      thumbnail: pic24,
      description: "Living room"
    },
    {
      original: pic25,
      thumbnail: pic25,
      description: "Queen bedroom"
    },
    {
      original: pic26,
      thumbnail: pic26,
      description: "King bedroom"
    },
    {
      original: pic27,
      thumbnail: pic27,
      description: "King bedroom"
    },
    {
      original: pic28,
      thumbnail: pic28,
      description: "King master bath"
    },
    {
      original: pic29,
      thumbnail: pic29,
      description: "King bedroom"
    },
    {
      original: pic30,
      thumbnail: pic30,
      description: "King bedroom"
    },
    {
      original: pic31,
      thumbnail: pic31,
      description: "King master bath"
    },
    {
      original: pic32,
      thumbnail: pic32,
      description: "King bedroom"
    },
    {
      original: pic33,
      thumbnail: pic33,
      description: "King bedroom"
    },
    {
      original: pic34,
      thumbnail: pic34,
      description: "King master bath"
    },
    {
      original: pic35,
      thumbnail: pic35,
      description: "Star Wars theme room"
    },
    {
      original: pic36,
      thumbnail: pic36,
      description: "Star Wars bunk beds"
    },
    {
      original: pic37,
      thumbnail: pic37,
      description: "Star Wars bath"
    },
    {
      original: pic38,
      thumbnail: pic38,
      description: "Princess bunk beds"
    },
    {
      original: pic39,
      thumbnail: pic39,
      description: "Frozen/Moana/Elana room"
    },
    {
      original: pic40,
      thumbnail: pic40,
      description: "2nd Floor bath"
    },
    {
      original: pic41,
      thumbnail: pic41,
      description: "King bedroom"
    },
    {
      original: pic42,
      thumbnail: pic42,
      description: "King bedroom"
    },
    {
      original: pic43,
      thumbnail: pic43,
      description: "King bath"
    },
    {
      original: pic44,
      thumbnail: pic44,
      description: "King bedroom"
    },
    {
      original: pic45,
      thumbnail: pic45,
      description: "King bedroom"
    },
    {
      original: pic46,
      thumbnail: pic46,
      description: "King bath"
    },
    {
      original: pic47,
      thumbnail: pic47,
      description: "Main Floor bath"
    }
  ];